import { render, staticRenderFns } from "./HeroSoftware.vue?vue&type=template&id=f6161fbc&scoped=true&"
import script from "./HeroSoftware.vue?vue&type=script&lang=js&"
export * from "./HeroSoftware.vue?vue&type=script&lang=js&"
import style0 from "./HeroSoftware.vue?vue&type=style&index=0&id=f6161fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6161fbc",
  null
  
)

export default component.exports